import { types } from '../actions/SettingsActions';
import _ from 'lodash';

const INITIAL_STATE = {
    initialized: false,
    showTitle: true,
    showDescription: true,
    customTitle: '',
    customDescription: '',
    customButton: '',
    layout: 0,
    alignment: 1,
    isCustomDesign: false,
    windowWidth: 0,
    windowHeight: 0
};

const HANDLERS = {
    [types.INIT_SETTINGS]: (payload, state) => {
        return {...state, ...payload, initialized: true};
    },

    [types.WINDOW_SIZE]: (payload, state) => {
        const { width, height } = payload;
        let newState = state;
        let hasChange = null;

        if (typeof width !== 'undefined' && width !== state.windowWidth) {
            hasChange = 'width';
        }
        if (typeof height !== 'undefined' && height !== state.windowHeight) {
            hasChange = hasChange ? 'both' : 'height';
        }

        if (hasChange) {
            newState = _.cloneDeep(state);
            if (hasChange === 'both') {
                newState.windowWidth = width;
                newState.windowHeight = height;
            } else {
                const propKey = hasChange === 'width' ? 'windowWidth' : 'windowHeight';
                newState[propKey] = payload[hasChange];
            }
        }

        return newState;
    }
};

export default function(state = INITIAL_STATE, action = {}) {
    let handler = HANDLERS[action.type] || (() => state);
    return handler(action.payload, state);
}
